var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table',_vm._l((_vm.commands),function(message){return _c('tr',{key:message.messageId},[_c('td',[_c('router-link',{attrs:{"to":{ name: 'message', params: { messageId: message.messageId }}}},[_vm._v(" "+_vm._s(message.messageId)+" ")])],1),_c('td',[_vm._v(_vm._s(message.type))]),_c('td',[_vm._v(_vm._s(message.created))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }